module.exports = __webpack_public_path__ + "static/media/features.a221c970.png";